import React from "react";
import {Route, Routes} from "react-router-dom";
import SuggestionList from "../container/suggestion/SuggestionList";
import CreateSuggestion from "../container/suggestion/CreateSuggestion";
import UpdateSuggestion from "../container/suggestion/UpdateSuggestion";
import AllSuggestion from "../container/suggestion/AllSuggestion";
import SuggestionRead from "../container/suggestion/SuggestionRead";
import SuggestionView from "../container/suggestion/SuggestionView";
import NotFound from "../pages/NotFound";
import {useRecoilValue} from "recoil";

import {levelSelector} from "../Recoil/Atom/authState";

const Suggestion = () => {
  const userLevel = useRecoilValue(levelSelector);
  return (
    <Routes>
      {/* {userLevel === 3 ? (
        <Route path="/*" element={<SuggestionList />} />
      ) : (
        <Route path="/*" element={<NotFound />} />
      )} */}
      {/* {userLevel === (1 || 2) ? (
        <Route path="All" element={<AllSuggestion />} />
      ) : (
        <Route path="/*" element={<NotFound />} />
      )} */}
      <Route path="/*" element={<SuggestionList />} />
      <Route path="All" element={<AllSuggestion />} />
      <Route path="Create" element={<CreateSuggestion />} />
      <Route path="Edit/:id" element={<UpdateSuggestion />} />
      <Route path="View/:id" element={<SuggestionView />} />
      <Route path="Read/:id" element={<SuggestionRead />} />
    </Routes>
  );
};

export default Suggestion;
